import {createFileRoute} from '@tanstack/react-router'

import AdsScreen from '@protected/ads'

export const Route = createFileRoute('/_protected/reddit')({component: () => <AdsScreen platform="reddit" />})
